export const AppSettingsService = {
	get: async (key: string, defaultReturn?: string) => {
		const value = localStorage.getItem(key);
		if (value) return value;
		else if (defaultReturn) return defaultReturn;
		else return undefined;
	},
	remove: async (key: string) => localStorage.removeItem(key),
	set: async (key: string, value: string) => localStorage.setItem(key, value)
}